import { useHistory } from "react-router-dom"

//styles
import './ConcessionsStart.css'


export default function ConcessionsStart() {
  const history = useHistory()

  const handleClick = (choice) => {
    if (choice === 'no') {
      history.push('/confirmation')
    } else if (choice === 'yes') {
      history.push('/concessions-name')
    }
  }

  return (
    <div className="concessions-start">
      <h1 className="text-accent-color">CONCESSION</h1>
      <div className='spacer'></div>
      <h2 className="text-light-color">Would anyone in your group like concessions?</h2>
      <div className='spacer-large'></div>
      <button className="main-button concessions" onClick={() => handleClick('yes')}>YES</button>
      <div className='spacer-large'></div>
      <button className="main-button secondary-button concessions" onClick={() => handleClick('no')}>NO</button>
    </div>
  )
}
